import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

export const columnOrderSlice = createSlice({
  name: "columnOrder",
  initialState,
  reducers: {
    setColumnOrder: (state, action) => {
      const { tableName, columnOrder } = action.payload;
      state[tableName] = columnOrder;
    },
    resetColumnOrder: (state, action) => {
      const { tableName, defaultColumnOrder } = action.payload;
      state[tableName] = defaultColumnOrder;
    },
  },
});

export const { setColumnOrder, resetColumnOrder } = columnOrderSlice.actions;

export default columnOrderSlice.reducer;
